import request from "../index";

// 获取关于我们分类
export function aboutType(postdata){
  return request({
      method:"get",
      url:"/aboutUsType/web/tree/",
      data:postdata,
      isparams:true
  })
}

// 获取关于我们详情
export function aboutDetail(postdata){
  return request({
      method:"post",
      url:"/aboutUs/web/page",
      data:postdata
  })
}


// 获取网站列表
export function webList(postdata){
  return request({
      method:"post",
      url:"/websiteManage/web/page",
      data:postdata
  })
}


// WEBPACK FOOTER //
// ./src/api/modules/about.js